const path = '$orgmap';
const ACCOUNT = '$account';

export const ORG_ME = `${path}/me`;
export const ORG_INIT = `${path}/init`;
export const ORG_LOADING = `${path}/loading`;
export const ORG_EVENT_TYPE = `${path}/event/type`;
export const ORG_CURRENT_TAB = `${path}/currentTab`;

export const ORG_MEMBER_LIST = `${path}/member/list`;
export const ORG_MEMBER_SELECT = `${path}/member/select`;
export const ORG_MEMBER_SELECT_ALL = `${path}/member/select/all`;
export const ORG_MEMBER_SEARCH = `${path}/member/search`;

export const ORG_CONTAINER_REGISTER = `${path}/container/register`;
export const ORG_CONTAINER_UPDATE = `${path}/container/update`;
export const ORG_CONTAINER_ITEM_ADD = `${path}/container/item/add`;
export const ORG_CONTAINER_ITEM_DEL = `${path}/container/item/del`;
export const ORG_CONTAINER_ITEM_SELECT = `${path}/container/item/select`;
export const ORG_CONTAINER_ITEM_SELECT_ALL = `${path}/container/item/select/all`;
export const ORG_CONTAINER_DEPT_ITEM_ADD = `${path}/container/dept/item/add`;
export const ORG_CONTAINER_ACTIVATE = `${path}/container/activate`;
export const ORG_CONTAINER_CLEAR = `${path}/container/clear`;

export const ORG_PUBLIC_FOLDER_LIST = `${path}/public/folder/list`;
export const ORG_PUBLIC_MEMBER_LIST = `${path}/public/member/list`;

export const ORG_PERSONAL_FOLDER_LIST = `${path}/personal/folder/list`;
export const ORG_PERSONAL_MEMBER_LIST = `${path}/personal/member/list`;
export const ORG_PERSONAL_GROUPMEMBER_LIST = `${path}/personal/group-member/list`;

export const ORG_OPTION_SET = `${path}/option/set`;
export const ORG_OPTION_GET = `${path}/option/get`;

export const ACCOUNT_CURRENT = `${ACCOUNT}/current`;

export const ORG_SELECT_TREE_ITEM = `${path}/treeitem/select`;

/**
 * 모바일
 */
export const ORG_USER_SELECT = `${path}/user/select`;
export const ORG_USER_SELECT_CLEAR = `${path}/user/select/clear`;
export const ORG_USER_SELECT_SET = `${path}/user/select/set`;


export const SEARCH_CHANGE = `${path}/search/change`
export const ORG_COMPANY_CURRENT = `${path}/company/current`

export const ORG_COMPANY_LIST = `${path}/company/list`;
export const ORG_COMPANY_LOAD = `${path}/company/load`;

export const ORG_COMPANY_LIST_WITHDISABLE = `${path}/company/list/withdisable`
export const ORG_COMPANY_LOAD_WITHDISABLE = `${path}/company/load/withdisable`

/**!SECTION
 *  HR TREE
 */
export const HR_TREE_LIST = `${path}/hr/tree/list`
export const HR_TREE_LIST_WITH_DISABLE = `${path}/hr/tree/list/withdisable`
export const HR_TREE_CURRENT = `${path}/hr/tree/current`
export const HR_TREE_CURRENT_V2 = `${path}/hr/tree/currentv2`
export const HR_TREE_CURRENT_V3 = `${path}/hr/tree/currentv3`
export const HR_TREE_PATH = `${path}/hr/tree/path`
export const HR_TREE_PATH_V2 = `${path}/hr/tree/pathv2`
export const HR_TREE_PATH_WITH_DISABLE = `${path}/hr/tree/path/withdisable`
export const HR_USERS_LIST = `${path}/hr/users/list`
export const HR_USERS_LIST_V2 = `${path}/hr/users/listv2`
export const HR_USERS_SEARCH = `${path}/hr/users/search`
export const HR_USERS_CURRENT = `${path}/hr/users/current`
export const HR_USER_SELALL = `${path}/hr/users/select-all`
export const HR_USERS_DEPTPERMSN = `${path}/hr/users/deptpermsn`
export const HR_USERS_DEPTPERMSN_WITH_DISABLE = `${path}/hr/users/deptpermsn/withdisable`